import { FC, ReactElement, ReactNode } from 'react'
import { Button, ButtonProps } from 'components/Button/Button'
import classNames from 'classnames'

export type ClickableCardButtonProps = ButtonProps & {
  icon: ReactElement | ReactNode
}

/**
 * This component uses the html button. Due to the behavior of browsers with buttons and display:flex,
 * this component may need wrapped in a parent div with display;flex in order for this to fill a column
 * with full width
 *
 * @param props
 * @returns
 */
export const ClickableCardButton: FC<ClickableCardButtonProps> = ({ children, icon, className, ...props }) => {
  return (
    // Default to full width for now. We only use this in one spot. Buttons don't work properly in a grid layout without parent wrappers.
    // This causes the clickable card component not to work quite right. This will need refactored at some point in the future.
    <Button
      className={classNames(
        'my-c-clickable-card',
        'my-u-width--full',
        className
      )}
      {...props}
    >
      {icon && <span className='ds-u-margin-right--2'>{icon}</span>}
      <span>{children}</span>
    </Button>)
}
